import { useApolloClient } from '@apollo/client';
import { loader } from 'graphql.macro';
import { getLocalTime } from '../../../../utilities/time';
import i18n from '../../../../i18n';
import { fetchReportPDFData } from '@opas-mobile/report-export';
import { buildReportExcelSheets as buildSheets } from '@opas-mobile/report-export';

const queryConfigs = {
  actionItems: {
    doc: loader('./CustomReport.actionItems.graphql'),
    dataKey: 'actionItems',
  },
  inspections: {
    doc: loader('./CustomReport.inspections.graphql'),
    dataKey: 'inspections',
  },
  incidents: {
    doc: loader('./CustomReport.incidents.graphql'),
    dataKey: 'incidents',
  },
  observations: {
    doc: loader('./CustomReport.observations.graphql'),
    dataKey: 'observations',
  },
  audits: {
    doc: loader('./CustomReport.inspections.graphql'),
    dataKey: 'inspections',
  },
  correctiveActions: {
    doc: loader('./CustomReport.correctiveActions.graphql'),
    dataKey: 'correctiveActions',
  },
  timecards: {
    doc: loader('./CustomReport.timecards.graphql'),
    dataKey: 'timecards',
  },
  expenses: {
    doc: loader('./CustomReport.expenses.graphql'),
    dataKey: 'expenses',
  },
};

const getReportDataQuery = loader('./CustomReports.getData.graphql');
const itemsQuery = loader('./ReportBuildMenuStats.items.graphql');
const templateRevisionIdsQuery = loader(
  './CustomReports.templateRevisionIds.graphql',
);

export function useReportPDFData() {
  const client = useApolloClient();

  const fetchPDFData = (report, modelLookups = {}, lookups = {}) =>
    fetchReportPDFData({
      report,
      modelLookups,
      lookups,
      client,
      docs: {
        queryConfigs,
        getReportData: getReportDataQuery,
        items: itemsQuery,
        templateRevisionIds: templateRevisionIdsQuery,
      },
      getTime: getLocalTime,
    });

  return { fetchPDFData };
}

export function buildReportExcelSheets(report, models, pdfData, lookups) {
  return buildSheets(report, models, pdfData, {
    t: i18n.t,
    getTime: getLocalTime,
    lookups,
  });
}
